import React from 'react';
import PropTypes from 'prop-types';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import Button from 'reactstrap/lib/Button';
import classnames from 'classnames';
import { CmsEntities } from 'client/data/models/cms';
import { getFullImageUrl } from 'client/utils/image-helpers';
import { makeNiceName } from 'site-modules/shared/utils/nice-name';
import { COMPARE_MODULE_PHOTO_SIZE } from 'site-modules/editorial/constants/best';
import { Link } from 'site-modules/shared/components/link/link';
import { AspectRatioContainer } from 'site-modules/shared/components/aspect-ratio-container/aspect-ratio-container';

import './compare-module.scss';

export function CompareModule({ entry, className = null }) {
  const title = entry.metadata('compare-title-header').value();
  const cta = entry.metadata('compare-title-button').value(entry.metadata('buttonText').value('Compare'));
  const vehicles = entry
    .links()
    .map(({ rel, href }, index) => {
      const vehicle = entry.vehicles.find(({ trim }) => trim === rel);
      if (!rel || !vehicle) {
        return null;
      }

      const { make, model, year, style, submodel } = vehicle;
      return {
        name: `${year} ${make} ${model} ${submodel || ''}`,
        styleParam: `veh${index + 1}=${style}`,
        photoUrl: getFullImageUrl(href, COMPARE_MODULE_PHOTO_SIZE),
        coreLink: `/${makeNiceName(make)}/${makeNiceName(model)}/${year}/${
          submodel ? `${makeNiceName(submodel)}/` : ''
        }`,
      };
    })
    .filter(value => value);
  const comparatorUrl = `/car-comparisons/?${vehicles.map(({ styleParam }) => styleParam).join('&')}`;

  if (!vehicles.length) {
    return null;
  }

  return (
    <div className={classnames('compare-module card align-items-center py-1', className)}>
      {!!title && <h3 className="heading-4 mb-1 mb-md-1_5 mx-0_25">{title}</h3>}
      <Row className="w-100 justify-content-center text-gray-darker p-0" tag="ul" style={{ listStyle: 'none' }}>
        {vehicles.map(({ name, styleParam, photoUrl, coreLink }) => (
          <Col xs={6} md={3} key={styleParam} className="mb-1 px-md-1" tag="li">
            <Link to={coreLink} className="d-block">
              <AspectRatioContainer aspectRatio="3:2" className="mb-0_5">
                <img className="w-100 rounded" src={photoUrl} alt="" />
              </AspectRatioContainer>
              {name}
            </Link>
          </Col>
        ))}
      </Row>
      <Button
        tag={Link}
        to={comparatorUrl}
        color="outline-primary-b"
        className="size-16 py-0_5 px-1"
        data-tracking-id="compare_button_click"
      >
        {cta}
      </Button>
    </div>
  );
}

CompareModule.propTypes = {
  entry: CmsEntities.Content.isRequired,
  className: PropTypes.string,
};
